<template>
  <v-layout
      row
      :style="maxWidth"
  >
    <v-flex
        class="ml-3"
        :style="maxWidth"
    >
      <breadcrumbs
          v-if="!qAdmin"
          :items="breadcrumbsItems"
      ></breadcrumbs>
      <breadcrumbs
          v-else
          :items="breadcrumbsItems1"
      ></breadcrumbs>
      <v-card
          class="ma-3 col-sm-6" outlined
      >
        <v-card-title>Edit Queue</v-card-title>
        <hr class="ma-1">
        <div class="col">
          <v-form
              ref="form"
              v-model="valid"
              lazy-validation
          >
            <v-text-field
                disabled
                label="Outlet"
                v-model="outlet.name"
            ></v-text-field>

            <v-text-field
                v-model="queue.name"
                :rules="nameRules"
                label="Name *"
                autocomplete="off"
                required
            ></v-text-field>

            <v-text-field
                v-model="queue.description"
                label="Description"
                autocomplete="off"
            ></v-text-field>

            <div class="pt-3 pl-3 pb-1">
              <v-row>
                <v-label class="mt-5">Operation Times</v-label>
                <v-btn
                    class="ml-2"
                    x-small
                    color="success"
                    @click="timesDialog = true"
                >
                  +
                </v-btn>
              </v-row>
              <div v-if="operationTimes.length > 0">
                <v-label>Operation:</v-label>
                <v-row class="pa-3">
                  <v-row>
                    <v-col class="pt-0 pb-0" cols="12" v-for="(ot) in operationTimes" :key="ot.id">
                      <v-input
                          append-icon="close"
                          background-color="#E3F2FD"
                      >
                        {{ convertDayName(ot.day) }} <br> {{ ot.time }}
                        <template slot="append" v-if="ot.timeslots">
                          <v-btn @click="timeslotLimit(ot.id)" color="primary" class="font-weight-bold">Set Limit
                          </v-btn>
                        </template>
                        <template slot="append" v-else>
                          <span style="font-size: small"> Please set interval and limit per interval to generate time slot</span>
                        </template>
                        <template slot="append">
                          <v-icon @click="removeOperationTime(ot)">close</v-icon>
                        </template>
                      </v-input>
                    </v-col>
                  </v-row>
                </v-row>
              </div>
              <div v-if="breakTimes.length > 0">
                <v-label>Break:</v-label>
                <v-row class="pa-3">
                  <v-input
                      v-for="(bt) in breakTimes"
                      append-icon="close"
                      :key="bt.id"
                      background-color="#F5F5F5"
                      @click:append="removeOperationTime(bt)"
                  >
                    {{ convertDayName(bt.day) }} <br> {{ bt.time }}
                  </v-input>
                </v-row>
              </div>
            </div>

            <v-switch
                v-model="queue.active"
                label="Active"
            ></v-switch>

            <v-text-field
                v-model="queue.interval"
                label="Interval (Minutes)"
                autocomplete="off"
                persistent-hint
                hint="*Please note that changing interval will reset timeslot limit."
            ></v-text-field>

            <v-text-field
                v-model="queue.duration"
                label="Timeslot duration"
                autocomplete="off"
                persistent-hint
            >
            </v-text-field>

            <v-text-field
                v-model="queue.limit"
                label="Pax limit per interval"
                autocomplete="off"
                type="number"
            ></v-text-field>

            <v-text-field
                v-model="queue.prefix"
                label="Prefix"
                autocomple="off"
            >
            </v-text-field>

            <v-text-field
                v-model="queue.queue_no_digit"
                label="Queue No Digit"
                autocomplete="off"
                type="number"
                max="5"
                persistent-hint
                hint="e.g.: set this value to 3, queue no format will be 001"
                class="pb-3"
            ></v-text-field>

            <v-text-field
                v-model="queue.message"
                label="Notify Message"
                autocomplete="off"
                counter
                maxlength="140"
                persistent-hint
                hint="Use {name} for customer name, e.g: 'Hi {name}' => 'Hi John'"
                class="pb-3"
            ></v-text-field>
            <v-text-field
                v-if="outlet.onsite_send_sms"
                v-model="queue.sms_available_soon"
                label="SMS for Available Soon"
                autocomplete="off"
                counter
                maxlength="100"
                persistent-hint
                hint="Use {name} for customer name, and {qlength} for current queue length. e.g: 'Hi {name}, there are {qlength} ahead of you' => 'Hi John, there are 8 ahead of you'"
                class="pb-3"
            ></v-text-field>
            <v-text-field
                v-if="outlet.onsite_send_sms"
                v-model="queue.sms_long_queue"
                label="SMS for Long Queue"
                autocomplete="off"
                counter
                maxlength="100"
                persistent-hint
                hint="Use {name} for customer name, and {qlength} for current queue length. e.g: 'Hi {name}, there are {qlength} ahead of you' => 'Hi John, there are 8 ahead of you'"
                class="pb-3"
            ></v-text-field>

            <v-switch
                v-model="queue.allow_pax_input"
                label="Allow pax input"
                @change="showPaxLimit = !showPaxLimit"
            ></v-switch>

            <v-text-field
                v-if="showPaxLimit"
                v-model="queue.pax_limit"
                label="Pax limit"
                type="number"
            >
            </v-text-field>

            <v-switch
                v-model="queue.display_queue_no"
                label="Display Queue No in Message"
            ></v-switch>

            <v-switch
                v-model="queue.auto_reminder"
                label="Send SMS reminder when there are N people ahead"
                @change="changeShowReminder"
            ></v-switch>
              <v-text-field
                  v-show="showReminder"
                  v-model="queue.reminder_trigger"
                  label="Reminder Trigger"
                  type="number"
                  persistent-hint
                  hint="When there is this number of people ahead in queue, SMS reminder will be sent automatically and sms charges will be applied."
                  max="10"
                  autocomplete="off"
              >
              </v-text-field>

            <v-switch
                v-model="queue.onsite_print"
                label="Onsite Print"
            ></v-switch>

            <v-switch
                v-model="queue.direct_print"
                label="Hide Onsite Print buttons and Print Directly"
            ></v-switch>

            <v-select
                :items="services"
                item-text="name"
                :return-object="true"
                label="Service"
                v-model="selectedServices"
                multiple
            ></v-select>

            <v-btn
                :disabled="!valid"
                color="success"
                class="mr-4 font-weight-bold"
                @click="submit"
            >
              Save
            </v-btn>
          </v-form>
        </div>
      </v-card>

      <v-dialog
          v-model="timesDialog"
          width="400"
      >
        <v-card>
          <v-row>
            <v-col>
              <v-card-title>Operation Time</v-card-title>
            </v-col>
            <v-col>
              <v-btn class="text-right float-right" text @click="timesDialog = !timesDialog">X</v-btn>
            </v-col>
          </v-row>
          <v-radio-group class="mt-0 pa-4" v-model="type" :mandatory="false" row>
            <v-radio label="Operation" value="operation" @change="changeDay('all')"></v-radio>
            <v-radio label="Break" value="break" @change="changeDay('break')"></v-radio>
          </v-radio-group>
          <v-select
              :items="days"
              :item-text="days.name"
              label="Day"
              v-model="day"
              multiple
              outlined
              class="mr-0 pl-4 col-11"
          ></v-select>
          <v-text-field
              v-model="time"
              label="Time"
              placeholder="e.g: 1300-1500"
              autocomplete="off"
              outlined
              class="mr-0 pl-4 col-11"
          ></v-text-field>
          <v-btn @click="addTime" class="font-weight-bold ml-4 mb-4" color="success">Save</v-btn>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
    valid: true,
    nameRules: [
      v => !!v || 'Name is required',
    ],
    timesDialog: false,
    type: 'operation',
    day: null,
    time: null,
    days: [],
    breakDays: '',
    daySelection: [
      {text: 'Sunday', value: 0},
      {text: 'Monday', value: 1},
      {text: 'Tuesday', value: 2},
      {text: 'Wednesday', value: 3},
      {text: 'Thursday', value: 4},
      {text: 'Friday', value: 5},
      {text: 'Saturday', value: 6}
    ],
    breakTimes: [],
    operationTimes: [],
    selectedServices: [],
    showPaxLimit: false,
    breadcrumbsItems: '',
    breadcrumbsItems1: '',
    showReminder: false,
  }),
  props: ['outlet', 'queue', 'services', 'queueservices', 'user'],
  computed: {
    qAdmin() {
      let isAdmin = this.user.role_id === 5;
      let correctGroup = this.user.group_id === this.outlet.group_id;
      return isAdmin && correctGroup;
    },
    maxWidth() {
      return {
        maxWidth: window.outerWidth + 'px'
      }
    }
  },
  methods: {
    changeShowReminder() {
      this.showReminder = !this.showReminder;
    },
    submit() {
      const prefix = '/outlet/' + this.outlet.id;
      if (this.$refs.form.validate()) {
        axios.post(prefix + '/queue/' + this.queue.id, {
          name: this.queue.name,
          description: this.queue.description,
          active: this.queue.active,
          interval: this.queue.interval,
          limit: this.queue.limit,
          // counter_no: this.queue.counter_no,
          message: this.queue.message,
          services: this.selectedServices,
          display_queue_no: this.queue.display_queue_no,
          allow_pax_input: this.queue.allow_pax_input,
          pax_limit: this.queue.pax_limit,
          duration: this.queue.duration,
          prefix: this.queue.prefix,
          queue_no_digit: this.queue.queue_no_digit,
          auto_reminder: this.queue.auto_reminder,
          reminder_trigger: this.queue.reminder_trigger,
          sms_available_soon: this.queue.sms_available_soon,
          sms_long_queue: this.queue.sms_long_queue,
          onsite_print: this.queue.onsite_print,
          direct_print: this.queue.direct_print
        }).then(result => {
            swal({
                title: 'Queue updated!',
                buttons: false,
                timer: 3000,
                icon: 'success'
            }).then( function () {
                window.location.reload()
                window.scrollTo(0, 0)
            })
        });
      }
    },
    addTime() {
      axios.post('/operation_times', {
        days: this.day,
        time: this.time,
        type: this.type,
        model_id: this.queue.id,
        model_type: 'App\\Queue'
      }).then(response => {
        response.data.type === 'operation' ? this.operationTimes.push(response.data) : this.breakTimes.push(response.data);
        if (response.data.type === 'operation') this.breakDays += response.data.day;
        let bd = '';
        this.operationTimes.forEach(function (t, idx, array) {
          if (idx !== array.length - 1) {
            bd += t.day + ','
          } else {
            bd += t.day
          }
        });
        this.breakDays = bd;
        // reset value
        this.type = 'operation';
        this.day = null;
        this.time = null;
        this.timesDialog = false;
      })
    },
    removeOperationTime(t) {
      // axios to remove operation time
      let type = t.type;
      const i = type === 'operation' ? this.operationTimes.indexOf(t) : this.breakTimes.indexOf(t);
      axios.delete('/operation_times/' + t.id).then(response => {
        type === 'operation' ? this.operationTimes.splice(i, 1) : this.breakTimes.splice(i, 1);
      });
    },
    createService() {
      window.location.href = '/outlet/' + this.outlet.id + '/service/create'
    },
    convertDayName(day) {
      let dayName = '';
      let d2 = day.split(",");
      this.daySelection.forEach(function (d) {
        d2.forEach(function (x, index, array) {
          if (d.value === parseInt(x)) {
            if (index === array.length - 1) {
              dayName += d.text
            } else {
              dayName += d.text + ', '
            }
          }
        })
      });
      return dayName;
    },
    changeDay(type) {
      if (type === 'all') this.days = this.daySelection;
      if (type === 'break') {
        let b = this.breakDays;
        let result = [];
        this.daySelection.forEach(function (d) {
          if (b.includes(d.value)) result.push(d);
        });
        this.days = result;
      }
    },
    timeslotLimit(operation_time) {
      window.location.href = '/queue/' + this.queue.id + '/operation_time/' + operation_time + '/timeslot'
    }
  },
  beforeMount() {
    this.showPaxLimit = this.queue.allow_pax_input;
    this.selectedServices = this.queueservices;
    axios.get('/api/operation_times/model?type=operation&qid=' + this.queue.id).then(response => {
      this.operationTimes = response.data;
      let bd = '';
      response.data.forEach(function (t, idx, array) {
        if (idx !== array.length - 1) {
          bd += t.day + ','
        } else {
          bd += t.day
        }
      });
      this.breakDays = bd;
    });
    axios.get('/api/operation_times/model?type=break&qid=' + this.queue.id).then(response => {
      this.breakTimes = response.data
    });
    this.days = this.daySelection;
    this.breadcrumbsItems = [
      {
        disabled: false,
        href: '/',
        link: true,
        text: 'Home',
      },
      {
        disabled: false,
        href: '/outlet/' + this.outlet.id + '/edit',
        link: true,
        text: this.outlet.name,
      },
      {
        disabled: true,
        href: '#',
        link: true,
        text: this.queue.name,
      },
    ];
    this.breadcrumbsItems1 = [
      {
        disabled: false,
        href: '/',
        link: true,
        text: 'Home',
      },
      {
        disabled: true,
        href: '#',
        link: true,
        text: this.queue.name,
      },
    ];
    this.showReminder = this.queue.auto_reminder
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Queues/QueueEdit.vue